import { apiSlice, defaultTransformFn } from 'api/apiSlice'
import { BillboardGeo } from 'api/entities/Billboard'

export interface BillboardQueryParams {
  zipCodes: string[]
}

const billboardApiTags = apiSlice.enhanceEndpoints({
  addTagTypes: ['BillboardLocations']
})

export const billboardApi = billboardApiTags.injectEndpoints({
  endpoints: build => ({
    getBillboardsByZipCodes: build.query<BillboardGeo[], BillboardQueryParams>({
      query: ({ zipCodes }) => {
        const zipCodesParam = zipCodes.map(zip => `zipCodes=${encodeURIComponent(zip)}`).join('&')
        return {
          url: `billboards/byZipCodes?${zipCodesParam}`,
          method: 'GET',
          isContext: true,
          isAgency: false
        }
      },
      transformResponse: defaultTransformFn,
      providesTags: (result, error, { zipCodes }) => [
        {
          type: 'BillboardLocations',
          id: [...zipCodes].sort().join(',')
        }
      ]
    })
  }),
  overrideExisting: false
})

export const { useGetBillboardsByZipCodesQuery, useLazyGetBillboardsByZipCodesQuery } = billboardApi
